var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGestinIntegraldeResiduosySeguridadAmbiental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "circle",
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    id: "OBJECT",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circle",
    d: "M15.94,9.67h6.67A7.68,7.68,0,0,0,30.27,2a1,1,0,0,0-1-1H25.94a7.67,7.67,0,0,0-6.67,3.89A7.65,7.65,0,0,0,12.61,1H9.27a1,1,0,0,0-1,1A7.68,7.68,0,0,0,15.94,9.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "circle",
    d: "M30.86,24A2.48,2.48,0,0,0,28,22.45l-4,.82a5.72,5.72,0,0,0,0-.58,3,3,0,0,0-3.1-2.92h0a8.08,8.08,0,0,1-3.76-.8l-1.89-.83A2.56,2.56,0,0,0,13.64,18a.66.66,0,0,0-.2.06l-1.24.56a6,6,0,0,1,.28,3.11L11.3,28.07c0,.15-.08.29-.12.44l5.35,2.06a6.09,6.09,0,0,0,2.26.43,6.17,6.17,0,0,0,2.31-.45l8.29-3.36A2.57,2.57,0,0,0,30.86,24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "circle",
    d: "M8,17.29l-5.82-.88A1,1,0,0,0,1,17.4v12a1,1,0,0,0,1,1H6.4a3.08,3.08,0,0,0,2.93-2.69l1.18-6.35a3.76,3.76,0,0,0-.61-2.84A2.88,2.88,0,0,0,8,17.29Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "circle",
    d: "M28,21.64A5,5,0,0,0,24,18.26a5,5,0,0,0-3.69-3.14V11.67h-2v3.45a5.06,5.06,0,0,0-2.94,1.81,2.88,2.88,0,0,1,.9.21l1.89.83a8.36,8.36,0,0,0,3.41.81h.35A3,3,0,0,1,25,21.69a5.72,5.72,0,0,1,0,.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestinIntegraldeResiduosySeguridadAmbiental);
export default __webpack_public_path__ + "static/media/Gestión Integral de Residuos y Seguridad Ambiental.98328d92a36d4e64bdeb1f1f7fa88dcb.svg";
export { ForwardRef as ReactComponent };